import Rewards from '@/components/Yotpo/rewards'
import { getMenu } from '@/utils/getSeoMenu';
import Head from 'next/head'
import React from 'react'

//OS-3066 : added to check if css issue gets fixed
export const getStaticProps = async () => {
  return {
    props: { menuElement : await getMenu("/") },
    revalidate: 60,
  };
};

function rewards() {
  return (
    <>
      <Head>
        <title>Olivela | Rewards Program</title>
        <meta name="description" content="An impactful rewards program unlike any other. Earn points and unlock exclusive extras every time you shop."></meta>
        <meta property="og:url" content={`${process.env.NETLIFY_URL}/account`}></meta>
        <meta
          property="og:image"
          content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}
        ></meta>
        <meta
          property="og:image:secure_url"
          content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}
        ></meta>
      </Head>
      <Rewards />
    </>
  )
}

export default rewards
